<template>
  <div>
    <b-modal ref="modal-rrhh-operation-payroll" :title="titleModal" modal-class="modal-primary"
      @hidden="$emit('hideModal')" size="xl" no-close-on-backdrop no-close-on-esc scrollable title-class="h6"
      :body-class="'px-0 overflow-x-hidden'">
      <!-- <div class="scroll-kanban p-75"> -->
      <b-row class="px-50">
        <b-col xl="4">
          <b-card class="card-app-design mb-1" body-class="py-0">
            <div class="d-flex justify-content-between">
              <h4 class="luxury-gradient-text d-flex align-items-center mb-0">
                <feather-icon icon="CalendarIcon" size="18" class="mr-50" /> ASISTENCIAS
              </h4>
              <feather-icon v-b-tooltip.hover.top="$t('Refresh Attendance')" icon="RefreshCcwIcon"
                class="text-warning cursor-pointer" size="17" @click="refreshAttendance" />
            </div>
            <div class="scroll-kanban mt-1" style="overflow-x: hidden; height: 50vh !important;">
              <div v-for="(data, key) in getAttendances" :key="key"
                class="d-flex justify-content-between align-items-center px-2" :class="key == 0 ? 'mt-2' : 'mt-1'">
                <feather-icon icon="CalendarIcon" class="text-success" size="17" />
                <div class="user-page-info ml-1">
                  <h6 class="mb-0">
                    {{ data.date | myGlobal }}
                  </h6>
                </div>

                <span class="cursor-pointer ml-3" v-b-tooltip.hover.left="data.comment != 'null' ? data.comment : ''
                  " @click="insertPersonalAttendance(data)">
                  <b-avatar rounded :variant="resolvColor(data.hs_id)" badge-top badge-variant="danger"
                    badge-offset="-2px">
                    <template #badge v-if="data.comment && data.comment != 'null'"></template>
                    <span v-if="data.hs_id">
                      {{ data.hs_name }}
                    </span>
                    <feather-icon v-else icon="AlertTriangleIcon" />
                  </b-avatar>
                </span>
              </div>
            </div>
          </b-card>

          <b-card class="card-app-design mb-1 mt-1" body-class="py-0">
            <h4 class="luxury-gradient-text d-flex align-items-center mb-1">
              <feather-icon icon="PieChartIcon" size="18" class="mr-50" /> RESUMEN DE ASISTENCIAS
            </h4>
            <div class="d-flex flex-column mt-1 mb-2 px-1">
              <div class="d-flex justify-content-between align-items-center pb-50 mb-50 border-bottom text-muted">
                 <span class="font-weight-bolder text-secondary">Total Días Computables:</span>
                 <b-badge variant="light-primary">{{ getAttendances.length }}</b-badge>
              </div>
              <div v-for="(item, index) in attendanceBreakdown" :key="index" class="d-flex justify-content-between align-items-center py-50" :class="{'border-bottom': index !== attendanceBreakdown.length - 1}">
                 <div class="d-flex align-items-center">
                    <feather-icon icon="CircleIcon" size="10" :class="resolvColor(item.hs_id).replace('light-', 'text-')" class="mr-50" />
                    <span class="font-weight-bolder text-capitalize" :class="resolvColor(item.hs_id).replace('light-', 'text-')">{{ item.name.toLowerCase() }}</span>
                 </div>
                 <b-badge :variant="resolvColor(item.hs_id)">{{ item.count }}</b-badge>
              </div>
            </div>
          </b-card>
        </b-col>

        <b-col xl="8">
          <b-row>
            <b-col md="12">
              <b-card class="card-app-design mb-1" body-class="py-1">
                <h4 class="luxury-gradient-text d-flex align-items-center mb-1">
                  <feather-icon icon="UserIcon" size="18" class="mr-50" /> INFORMACION GENERAL
                </h4>

                <div class="d-flex flex-column gap-y-3 mt-2">
                  <div class="d-flex gap-3">
                    <span class="text-primary">Area:</span>
                    <strong>{{ department }}</strong>
                  </div>

                  <div class="d-flex  justify-content-between">
                    <b-media no-body>
                      <b-media-aside class="mr-1">
                        <b-avatar rounded variant="light-primary" size="34">
                          <feather-icon icon="CalendarIcon" size="18" />
                        </b-avatar>
                      </b-media-aside>
                      <b-media-body>
                        <h6 class="mb-0">{{ start_date_work | myDateEs }}</h6>
                        <small> Inicio Laboral </small>
                      </b-media-body>
                    </b-media>

                    <div v-if="fecha_cese != null" class="d-flex align-items-center gap-3">
                      <b-avatar rounded variant="light-danger" size="34">
                        <feather-icon icon="CalendarIcon" size="18" />
                      </b-avatar>
                      <div class="d-flex flex-column" style="width: 100px;">
                        <h6 class="mb-0">{{ fecha_cese | myDateEs }}</h6>
                        <small> Fecha Cese </small>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex justify-content-between">
                    <b-media no-body>
                      <b-media-aside class="mr-1">
                        <b-avatar rounded variant="light-primary" size="34">
                          <feather-icon icon="CalendarIcon" size="18" />
                        </b-avatar>
                      </b-media-aside>
                      <b-media-body>
                        <h6 class="mb-0">{{ cutOfDate | myDateEs }}</h6>
                        <small> {{ $t("Cut of Date") }} </small>
                      </b-media-body>
                    </b-media>

                    <div class="d-flex align-items-center gap-3" v-if="payment_method == 'fornightly'">
                      <b-avatar rounded variant="light-primary" size="34">
                        S/.
                      </b-avatar>

                      <div class="d-flex flex-column" style="width: 100px">
                        <p class="card-text mb-25 text-primary">
                          1era Quincena
                        </p>
                        <h6 class="mb-0">S/ {{ fortnightAmount | currency }}</h6>
                      </div>
                    </div>

                    <div v-if="isMonthly" class="d-flex align-items-center gap-3">
                      <b-avatar rounded variant="light-primary" size="34">
                        S/.
                      </b-avatar>
                      <div class="d-flex flex-column" style="width: 100px">
                        <h6 class="mb-0">S/ {{ monthlyAmount }}</h6>
                        <p class="card-text mb-25 text-primary">
                          {{ payment_method == 'fornightly' ? '2da Quincena' : 'Mensual' }}
                        </p>
                      </div>
                    </div>

                  </div>
                </div>

              </b-card>
            </b-col>

            <!-- INFORMACION SALARIAL -->
            <b-col md="5">
              <b-card class="card-app-design mb-1" body-class="py-0">
                <h4 class="luxury-gradient-text d-flex align-items-center mb-1">
                  <feather-icon icon="DollarSignIcon" size="18" class="mr-50" /> INFORMACION SALARIAL
                </h4>
                <div class="" style="height: 200px; overflow-y: auto">
                  <b-table-simple hover small striped caption-top responsive class="position-relative font-small-3"
                    table-class="text-nowrap" sticky-header="50vh">
                    <b-thead head-variant="light">
                      <b-tr>
                        <b-th> CONCEPTO </b-th>
                        <b-th> VALOR </b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr>
                        <b-td> SUELDO BASE: </b-td>
                        <b-td class="text-primary">
                          S/. {{ basicSalary | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> BONIFICACION: </b-td>
                        <b-td class="text-primary">
                          S/. {{ bonification | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> SALARIO DIARIO: </b-td>
                        <b-td class="text-primary">
                          S/. {{ salaryPerDay | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> SUELDO AFECTO: </b-td>
                        <b-td class="text-primary">
                          S/. {{ salary_afecto | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> SALARIO DIARIO AFECTO: </b-td>
                        <b-td class="text-primary">
                          S/. {{ salary_per_day_afecto | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> DOMINICAL: </b-td>
                        <b-td class="text-primary">
                          S/. {{ salario_dominical | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td colspan="2"></b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> DIAS PAGADOS: </b-td>
                        <b-td class="text-primary"> {{ workedDays }} </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> DIAS NO PAGADOS: </b-td>
                        <b-td class="text-danger"> {{ notWorkedDays }} </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td colspan="2"></b-td>
                      </b-tr>
                      <template v-if="payment_method == 'fornightly'">
                        <b-tr>
                          <b-td> FALTAS 1ERA QUINCENA: </b-td>
                          <b-td class="text-danger"> {{ cantidad_faltas_quincena }} </b-td>
                        </b-tr>
                        <b-tr v-if="isMonthly">
                          <b-td> FALTAS 2DA QUINCENA: </b-td>
                          <b-td class="text-danger"> {{ cantidad_faltas_mes }} </b-td>
                        </b-tr>
                      </template>
                    </b-tbody>
                  </b-table-simple>
                </div>
              </b-card>
            </b-col>

            <!-- RESUMEN DE DESCUENTOS -->
            <b-col md="7">
              <b-card class="card-app-design mb-1" body-class="py-0">
                <h4 class="luxury-gradient-text d-flex align-items-center mb-1">
                  <feather-icon icon="TrendingDownIcon" size="18" class="mr-50" /> RESUMEN DE DESCUENTOS Y ADICIONALES
                </h4>
                <div class="" style="height: 200px; overflow-y: auto">
                  <b-table-simple hover small striped caption-top responsive class="position-relative font-small-3"
                    table-class="text-nowrap" sticky-header="50vh">
                    <b-thead head-variant="light">
                      <b-tr>
                        <b-th> CONCEPTO </b-th>
                        <b-th> VALOR </b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr>
                        <b-td> BONIFICACION: </b-td>
                        <b-td class="text-primary">
                          S/. +
                          {{ (bono_quincena + bono_mensual) | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> FALTAS: </b-td>
                        <b-td class="text-danger">
                          S/. {{ descuento_falta | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> DOMINICAL: </b-td>
                        <b-td class="text-danger">
                          S/. {{ total_dominical | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr v-if="tipo_planilla == 'Planilla'">
                        <b-td> APORTES: </b-td>
                        <b-td class="text-danger">
                          S/. {{ descuento_aportes | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr v-if="tipo_planilla == 'Planilla'">
                        <b-td> RET. QUINTA: </b-td>
                        <b-td class="text-danger">
                          S/. {{ descuento_quinta | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> POR CONCEPTO: </b-td>
                        <b-td class="text-danger">
                          S/. {{ descuento_por_concepto | currencyZero }}
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </div>
              </b-card>
            </b-col>

            <!-- DETALLE RET. QUINTA -->
            <b-col md="5" v-if="tipo_planilla == 'Planilla'">
              <b-card class="card-app-design mb-1" body-class="py-0">
                <h4 class="luxury-gradient-text d-flex align-items-center mb-1">
                  <feather-icon icon="PercentIcon" size="18" class="mr-50" /> DETALLE RET. QUINTA
                </h4>
                <div class="" style="height: 200px; overflow-y: auto">
                  <b-table-simple hover small striped caption-top responsive class="position-relative font-small-3"
                    table-class="text-nowrap" sticky-header="50vh">
                    <b-thead head-variant="light">
                      <b-tr>
                        <b-th> CONCEPTO </b-th>
                        <b-th> VALOR </b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr>
                        <b-td> SUELDO ANUAL: </b-td>
                        <b-td v-if="sueldo_anio > 0" class="text-danger">
                          S/. {{ sueldo_anio | currencyZero }}
                        </b-td>
                        <b-td v-else class="text-danger"> - </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> GRATIF. ANUAL: </b-td>
                        <b-td v-if="sueldo_anio > 0" class="text-danger">
                          S/. {{ gratificacion_anio | currencyZero }}
                        </b-td>
                        <b-td v-else class="text-danger"> - </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> BONO EXTRAOR.: </b-td>
                        <b-td v-if="sueldo_anio > 0" class="text-danger">
                          S/. {{ bono_extraordinario_anio | currencyZero }}
                        </b-td>
                        <b-td v-else class="text-danger"> - </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> SUELDO BRUTO ANUAL: </b-td>
                        <b-td v-if="sueldo_anio > 0" class="text-danger">
                          S/. {{ sueldo_bruto_anio | currencyZero }}
                        </b-td>
                        <b-td v-else class="text-danger"> - </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> MONTO DEDUCIBLE: </b-td>
                        <b-td v-if="sueldo_anio > 0" class="text-danger">
                          S/. {{ monto_deducible | currencyZero }}
                        </b-td>
                        <b-td v-else class="text-danger"> - </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> BASE NETA: </b-td>
                        <b-td v-if="sueldo_anio > 0" class="text-danger">
                          S/. {{ base_neta | currencyZero }}
                        </b-td>
                        <b-td v-else class="text-danger"> - </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> IMPUESTO TOTAL: </b-td>
                        <b-td v-if="sueldo_anio > 0" class="text-danger">
                          S/. {{ monto_total_impuesto | currencyZero }}
                        </b-td>
                        <b-td v-else class="text-danger"> - </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> TOTAL A DESCONTAR: </b-td>
                        <b-td v-if="sueldo_anio > 0" class="text-danger">
                          S/. {{ descuento_quinta | currencyZero }}
                        </b-td>
                        <b-td v-else class="text-danger"> - </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </div>
              </b-card>
            </b-col>

            <!-- DETALLE DESC. APORTES -->
            <b-col md="7" v-if="tipo_planilla == 'Planilla'">
              <b-card class="card-app-design mb-1" body-class="py-0">
                <h4 class="luxury-gradient-text d-flex align-items-center mb-1">
                  <feather-icon icon="ShieldIcon" size="18" class="mr-50" /> DETALLE DESC. APORTES
                </h4>
                <div class="" style="height: 200px; overflow-y: auto">
                  <b-table-simple hover small striped caption-top responsive class="position-relative font-small-3"
                    table-class="text-nowrap" sticky-header="50vh">
                    <b-thead head-variant="light">
                      <b-tr>
                        <b-th> CONCEPTO </b-th>
                        <b-th> PORCENTAJE </b-th>
                        <b-th> MONTO </b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr>
                        <b-td> PENSION: </b-td>
                        <b-td v-if="pension_fund_id != null" class="">
                          {{ aporte_nombre }}
                        </b-td>
                        <b-td v-else>-</b-td>

                        <b-td>-</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> TIPO COMISION: </b-td>
                        <b-td v-if="pension_fund_id != null" class="">
                          {{ tipo_comision ? tipo_comision.toUpperCase() : "" }}
                        </b-td>
                        <b-td v-else>-</b-td>

                        <b-td>-</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> CONTRIBUCION: </b-td>
                        <b-td v-if="pension_fund_id != null" class="text-primary">
                          % {{ porcentaje_contribucion }}
                        </b-td>
                        <b-td v-else>-</b-td>

                        <b-td v-if="pension_fund_id != null" class="text-danger">
                          S/. {{ monto_contribucion | currencyZero }}
                        </b-td>
                        <b-td v-else>-</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> SEGURO: </b-td>
                        <b-td v-if="pension_fund_id != null" class="text-primary">
                          % {{ porcentaje_seguro }}
                        </b-td>
                        <b-td v-else>-</b-td>

                        <b-td v-if="pension_fund_id != null" class="text-danger">
                          S/. {{ monto_seguro | currencyZero }}
                        </b-td>
                        <b-td v-else>-</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> COMISION: </b-td>
                        <b-td v-if="pension_fund_id != null" class="text-primary">
                          % {{ porcentaje_comision }}
                        </b-td>
                        <b-td v-else>-</b-td>

                        <b-td v-if="pension_fund_id != null" class="text-danger">
                          S/. {{ monto_comision | currencyZero }}
                        </b-td>
                        <b-td v-else>-</b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </div>
              </b-card>
            </b-col>

            <!-- PAGO ADICIONAL -->
            <b-col md="5" v-if="tiene_otro_pago == 1">
              <b-card class="card-app-design mb-1" body-class="py-0">
                <h4 class="luxury-gradient-text d-flex align-items-center mb-1">
                  <feather-icon icon="PlusCircleIcon" size="18" class="mr-50" /> PAGO ADICIONAL
                </h4>
                <div class="" style="height: 200px; overflow-y: auto">
                  <b-table-simple hover small striped caption-top responsive class="position-relative font-small-3"
                    table-class="text-nowrap" sticky-header="50vh">
                    <b-thead head-variant="light">
                      <b-tr>
                        <b-th> CONCEPTO </b-th>
                        <b-th> VALOR </b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr>
                        <b-td> SUELDO BASE: </b-td>
                        <b-td class="text-primary">
                          S/. {{ or_salary | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> BONIFICACION: </b-td>
                        <b-td class="text-primary">
                          S/. {{ or_bonification | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> SUELDO DIARIO: </b-td>
                        <b-td class="text-primary">
                          S/. {{ or_salary_per_day | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> SALARIO DOMINICAL: </b-td>
                        <b-td class="text-primary">
                          S/. {{ or_salario_dominical | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> PAGO QUINCENA: </b-td>
                        <b-td class="text-primary">
                          S/. {{ or_fortnight_amount | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> BONO QUINCENA: </b-td>
                        <b-td class="text-primary">
                          S/. {{ or_bono_quincena | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> DESCUENTOS FALTAS: </b-td>
                        <b-td class="text-danger">
                          S/. {{ or_total_descuento_faltas | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> DESCUENTOS DOMINICAL: </b-td>
                        <b-td class="text-danger"> S/. {{ or_total_dominical | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> DESCUENTOS CONCEPTO: </b-td>
                        <b-td class="text-danger">
                          S/. {{ or_total_descuento_otros | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> DESCUENTOS TOTAL: </b-td>
                        <b-td class="text-danger">
                          S/. {{ or_total_descuento | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> BONO FIN DE MES: </b-td>
                        <b-td class="text-primary">
                          S/. {{ or_bono_mensual | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> PAGO MES: </b-td>
                        <b-td class="text-primary">
                          S/. {{ or_total_amount | currencyZero }}
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </div>
              </b-card>
            </b-col>

            <!-- List Discounts -->
            <b-col :md="tiene_otro_pago == 1 ? '7' : '12'">
              <b-card class="card-app-design mb-1" body-class="py-0">
                <h4 class="luxury-gradient-text d-flex align-items-center mb-1">
                  <feather-icon icon="MinusCircleIcon" size="18" class="mr-50" /> DESCUENTOS POR CONCEPTO
                </h4>
                <div class="" style="height: 220px; overflow-y: auto" v-if="discounts.length">
                  <b-table-simple hover small caption-top responsive class="position-relative font-small-3"
                    table-class="text-nowrap" sticky-header="50vh">
                    <b-thead head-variant="light">
                      <b-tr>
                        <b-th> {{ $t("Registered At") }} </b-th>
                        <b-th> {{ $t("Discount Date") }} </b-th>
                        <b-th> {{ $t("Type") }} </b-th>
                        <b-th> {{ $t("Amount") }} </b-th>
                        <b-th> {{ $t("Status") }} </b-th>
                        <b-th> </b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <template v-for="(disc, key) in discounts">
                        <b-tr :key="key">
                          <b-td> {{ disc.date | globalDate }} </b-td>
                          <b-td> {{ disc.discount_date | globalDate }} </b-td>
                          <b-td> {{ disc.discount_type_name }} </b-td>
                          <b-td>
                            <b-badge variant="light-primary">
                              S/ {{ disc.amount | currency }}
                            </b-badge>
                          </b-td>
                          <b-td>
                            <b-badge :variant="disc.status_fraction == 'Discounted'
                              ? 'light-success'
                              : 'light-warning'
                              ">
                              {{ disc.status_fraction }}
                            </b-badge>
                          </b-td>
                          <b-td>
                            <b-form-checkbox v-model="disc.check" :disabled="disc.status_fraction == 'Discounted' || isView
                              " :value="1" class="custom-control-primary" @change="addDiscountToPayroll(disc)">
                            </b-form-checkbox>
                          </b-td>
                        </b-tr>
                      </template>
                    </b-tbody>
                    <b-tfoot>
                      <b-tr>
                        <b-td colspan="3" class="text-right" style="opacity: 0.7; font-size: 13px">
                          {{ $t("Total Discount") }}:
                        </b-td>
                        <b-td colspan="2" style="opacity: 0.7; font-size: 13px">
                          <b-badge variant="light-danger">
                            S/ {{ getTotalDiscount | currency }}
                          </b-badge>
                        </b-td>
                      </b-tr>
                    </b-tfoot>
                  </b-table-simple>
                </div>

                <div v-else style="height: 220px; overflow-y: auto"
                  class="d-flex align-items-center justify-content-center">
                  <b-alert variant="primary" style="height: 100px" show
                    class="w-100 mx-3 d-flex align-items-center justify-content-center">
                    <div class="alert-body">
                      <span style="font-size: 16px">
                        <strong> {{ $t("Not register discounts") }}. </strong>
                      </span>
                    </div>
                  </b-alert>
                </div>
                <b-row></b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- </div> -->

      <template #modal-footer>
        <div class="text-right">
          <b-button variant="outline-danger" :class="isReadyApprove == 1 ? 'mr-1' : ''" @click="$emit('hideModal')">
            {{ $t("close").toUpperCase() }}
          </b-button>
          <b-button v-if="isReadyApprove == 1 && !isView" variant="outline-primary" @click="approvePayroll">
            {{ $t("Approve").toUpperCase() }}
          </b-button>
          <b-button v-if="isReadyApprove == 0" class="ml-1" variant="outline-primary" @click="calculatePayrollById">
            RECALCULAR
          </b-button>
          <!-- <b-button
          v-if="approved"
          variant="outline-success"
          @click="saveComment"
          >{{ $t("Save Comment") }}</b-button
        > -->
        </div>
      </template>
    </b-modal>

    <PersonalAttendanceModal v-if="personalAttendanceModal" :dataModal="attendanceData"
      @hideModal="personalAttendanceModal = false" @refreshPayroll="
        personalAttendanceModal = false;
      refreshAttendance();
      isReadyApprove = 0;
      " />
    <PlanillaConfirmacionModal v-if="showConfirmacionPlanillaModal" :idPlanillas="idPlanillasToApprove"
      :tipo="'CONDUCTOR'" @close="showConfirmacionPlanillaModal = false"
      @confirmed="handleConfirmacionAprobacionPlanilla" />
  </div>
</template>

<script>
import moment from "moment";
import Ripple from "vue-ripple-directive";

import flatPickr from "vue-flatpickr-component";
import { mapGetters } from "vuex";
import modalMixin from "@/mixins/modal";
import PersonalAttendanceModal from "@/views/monitoring/views/attendance/components/modals/PersonalAttendance.vue";

import PayrollService from "@/views/rrhh/views/payroll/services/payroll.service.js";
import ViaticService from "@/views/monitoring/views/viatic/services/viatic.service.js";
import PlanillaConfirmacionModal from "@/views/rrhh/views/payroll/components/administrative-payroll/PlanillaConfirmacionModal.vue";

export default {
  mixins: [modalMixin],
  components: {
    flatPickr,
    PersonalAttendanceModal,
    PlanillaConfirmacionModal,
  },
  props: {
    dataModal: {
      type: Object,
    },
    payrollId: {
      type: Number,
      default: null,
    },
    isView: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      showConfirmacionPlanillaModal: false,
      employeeId: null,
      employeeName: null,
      attendanceId: null,
      attendanceCode: null,
      startDate: null,
      cutOfDate: null,
      fecha_cese: null,
      basicSalary: 0,
      bonification: 0,
      notRegistered: 0,
      workedDays: 0,
      notWorkedDays: 0,
      salaryPerDay: 0,
      totalDiscount: 0,
      fortnightAmount: 0,
      isReadyApprove: 0,
      isMonthly: false,
      department: "",

      tipo_planilla: null,
      area_id: null,
      payment_method: null,

      descuento_falta: 0,
      descuento_aportes: 0,
      descuento_quinta: 0,
      descuento_por_concepto: 0,

      pension_fund_id: null,
      aporte_nombre: "",
      tipo_comision: "",
      porcentaje_contribucion: 0,
      monto_contribucion: 0,
      porcentaje_seguro: 0,
      monto_seguro: 0,
      porcentaje_comision: 0,
      monto_comision: 0,

      sueldo_anio: 0,
      gratificacion_anio: 0,
      bono_extraordinario_anio: 0,
      sueldo_bruto_anio: 0,
      monto_deducible: 0,
      base_neta: 0,
      monto_total_impuesto: 0,

      salary_afecto: 0,
      salary_per_day_afecto: 0,

      bono_quincena: 0,
      bono_mensual: 0,

      salario_dominical: 0,
      monto_dominical_quincena: 0,
      monto_dominical_mes: 0,
      total_dominical: 0,

      or_salario_dominical: 0,
      or_monto_dominical_quincena: 0,
      or_monto_dominical_mes: 0,
      or_total_dominical: 0,

      or_bono_quincena: 0,
      or_bono_mensual: 0,

      // PAGO ADICIONAL
      tiene_otro_pago: 0,
      or_type_form: null,
      or_labor_regime_id: null,
      or_salary: 0,
      or_bonification: 0,
      or_salary_per_day: 0,
      or_fortnight_amount: 0,
      or_descuento_x_tardanza: 0,
      or_monthly_descuento_tardanza: 0,
      or_descuento_x_falta: 0,
      or_monthly_descuento_falta: 0,
      or_others_discount: 0,
      or_monthly_others_discount: 0,
      or_total_descuento: 0,
      or_total_amount: 0,

      or_total_descuento_tardanzas: 0,
      or_total_descuento_faltas: 0,
      or_total_descuento_otros: 0,

      data_salario_actual: null,
      start_date_work: null,

      cantidad_faltas_quincena: 0,
      cantidad_faltas_mes: 0,

      personalAttendanceModal: false,
      monthlyAmount: 0,
      attendanceData: {},
      form: {
        attendance_id: null,
        user_id: null,
        homework_status_id: null,
        observation: null,
        comment: null,
        attendance_date: null,
        is_viatic: 1,
        status: 1,
      },
      attendances: [],
      discounts: [],
      disabled: false,
      approved: false,
      status_id: null,
      payroll_id: null,
      flatConfig: {
        enableTime: true,
        dateFormat: "Y-m-d H:i",
        enable: [],
      },
    };
  },
  mounted() {
    this.toggleModal("modal-rrhh-operation-payroll");
  },
  async created() {
    await this.getDataOperationPayrollById();
    // console.log("dataModa: ", this.dataModal);
    // if (this.dataModal.origin == "viatic") {
    //   this.form.attendance_date = this.dataModal.date;
    //   this.form.homework_status_id = this.dataModal.homework_status_id;
    //   this.form.observation = this.dataModal.observation;
    //   this.form.comment =
    //     this.dataModal.comment == "null" ? null : this.dataModal.comment;
    //   this.disabled = true;
    //   this.approved = this.dataModal.approved;
    //   this.status_id = this.dataModal.attendance_status_viatic_id;
    //   this.payroll_id = this.dataModal.payroll_id;
    // }
    // await this.getHomeworkStatuses();
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    getCurrentBrackPoint() {
      return this.$store.getters["app/currentBreakPoint"];
    },
    getTotalDiscount() {
      let total = 0;
      this.discounts.map((dis) => {
        total += dis.amount;
      });
      return total;
    },
    // getAttendances() {
    //   if (this.fecha_cese != null) {
    //     return this.attendances.filter((att) =>
    //       moment(att.date).isSameOrAfter(this.start_date_work) &&
    //       moment(att.date).isSameOrBefore(moment(this.fecha_cese))
    //     );
    //   } else {
    //     return this.attendances.filter((att) =>
    //       moment(att.date).isSameOrAfter(this.start_date_work)
    //     );
    //   }

    // },
    getAttendances() {
      const start = moment(this.startDate);   // 2025-12-01
      const end = this.fecha_cese
        ? moment(this.fecha_cese)
        : moment(this.cutOfDate);             // 2025-12-31

      return this.attendances.filter(att => {
        const attDate = moment(att.date);
        return attDate.isBetween(start, end, 'day', '[]');
      });
    },

    attendanceBreakdown() {
      if (!this.getAttendances || !this.getAttendances.length) return [];
      
      let breakdown = {};
      this.getAttendances.forEach(att => {
        let name = att.hs_name || 'No Registrado';
        let hs_id = att.hs_id || null;
        
        if (!breakdown[name]) {
          breakdown[name] = { count: 0, hs_id: hs_id };
        }
        breakdown[name].count++;
      });
      
      return Object.entries(breakdown).map(([name, data]) => ({
        name: name,
        count: data.count,
        hs_id: data.hs_id
      }));
    },

    titleModal() {
      return `${this.$t("PAYROLL APPROVE")}: ${this.employeeName}`;
    },
    idPlanillasToApprove() {
      let planillas = [];

      planillas.push({
        user_id: this.currentUser.id,
        payroll_id: this.payrollId,
      });

      return planillas;
    },
  },
  methods: {
    async getDataOperationPayrollById() {
      try {
        this.addPreloader();
        const { data } = await PayrollService.getDataOperationPayrollById({
          payroll_id: this.payrollId,
          option: 1,
        });
        this.isView = [1, 4].includes(data[0].status_id) ? false : true;
        this.start_date_work = moment(data[0].start_date_work);
        this.employeeId = data[0].employee_id;
        this.employeeName = data[0].employee_name;
        this.attendanceId = data[0].attendance_id;
        this.attendanceCode = data[0].code;
        this.startDate = data[0].start_date;
        this.fortnightCutDay = data[0].fornight_cut_day;
        this.cutOfDate = data[0].month;
        this.fecha_cese = data[0].fecha_cese;
        this.basicSalary = data[0].salary_per_month;
        this.notRegistered = data[0].not_registered;
        this.workedDays = data[0].worked_days;
        this.notWorkedDays = data[0].not_worked_days;
        this.salaryPerDay = data[0].salary_per_day;
        this.totalDiscount = data[0].total_discount;
        this.fortnightAmount = data[0].fortnight_amount;
        this.isReadyApprove = data[0].is_ready_approve;
        this.monthlyAmount = data[0].total;
        this.department = data[0].department;
        this.area_id = data[0].area_id;
        this.isMonthly = data[0].is_monthly == 1;
        this.bonification = data[0].bonification;

        this.cantidad_faltas_quincena = data[0].cantidad_faltas_quincena;
        this.cantidad_faltas_mes = data[0].cantidad_faltas_mes;

        /* Dominical */
        this.salario_dominical = parseFloat(data[0].salario_dominical);
        this.monto_dominical_quincena = parseFloat(data[0].monto_dominical_quincena);
        this.monto_dominical_mes = parseFloat(data[0].monto_dominical_mes);
        this.total_dominical =
          this.monto_dominical_quincena + this.monto_dominical_mes;

        this.or_salario_dominical = parseFloat(data[0].or_salario_dominical);
        this.or_monto_dominical_quincena = parseFloat(data[0].or_monto_dominical_quincena);
        this.or_monto_dominical_mes = parseFloat(data[0].or_monto_dominical_mes);
        this.or_total_dominical =
          this.or_monto_dominical_quincena + this.or_monto_dominical_mes;

        this.salary_afecto = parseFloat(data[0].salary_afecto);
        this.salary_per_day_afecto = this.salary_afecto / 30;

        this.bono_quincena = parseFloat(data[0].bono_quincena);
        this.bono_mensual = parseFloat(data[0].bono_mensual);

        this.or_bono_quincena = parseFloat(data[0].or_bono_quincena);
        this.or_bono_mensual = parseFloat(data[0].or_bono_mensual);

        // Resumen de descuentos
        this.descuento_falta =
          parseFloat(data[0].descuento_x_falta) +
          parseFloat(data[0].monthly_descuento_falta);
        this.descuento_aportes =
          parseFloat(data[0].monto_contribucion) +
          parseFloat(data[0].monto_seguro) +
          parseFloat(data[0].monto_comision) +
          parseFloat(data[0].monto_contribucion_quincena) +
          parseFloat(data[0].monto_seguro_quincena) +
          parseFloat(data[0].monto_comision_quincena);
        this.descuento_quinta = parseFloat(data[0].monto_quinta);
        this.descuento_por_concepto =
          parseFloat(
            data[0].others_discount != null ? data[0].others_discount : 0
          ) + parseFloat(data[0].monthly_others_discount);

        // Detalle de aportes
        this.pension_fund_id = data[0].pension_fund_id;
        this.aporte_nombre = data[0].pension_fund_name;
        this.tipo_comision = data[0].tipo_comision;
        this.porcentaje_contribucion = data[0].porcentaje_contribucion;
        this.monto_contribucion =
          parseFloat(data[0].monto_contribucion) +
          parseFloat(data[0].monto_contribucion_quincena);
        this.porcentaje_seguro = data[0].porcentaje_seguro;
        this.monto_seguro =
          parseFloat(data[0].monto_seguro) +
          parseFloat(data[0].monto_seguro_quincena);
        this.porcentaje_comision =
          data[0].tipo_comision == "mixto"
            ? data[0].porcentaje_comision_mixto
            : data[0].porcentaje_comision;
        this.monto_comision =
          parseFloat(data[0].monto_comision) +
          parseFloat(data[0].monto_comision_quincena);

        // Detalle de impuesto ret. quinta
        this.sueldo_anio = data[0].sueldo_anio;
        this.gratificacion_anio = data[0].gratificacion_anio;
        this.bono_extraordinario_anio = data[0].bono_extraordinario_anio;
        this.sueldo_bruto_anio = data[0].sueldo_bruto_anio;
        this.monto_deducible = data[0].monto_deducible;
        this.base_neta = data[0].base_neta;
        this.monto_total_impuesto = data[0].monto_total_impuesto;

        this.tipo_planilla = data[0].type_form;
        this.payment_method = data[0].payment_method;
        // PAGO ADICIONAL
        this.tiene_otro_pago = data[0].tiene_otro_pago;
        this.or_type_form = data[0].or_type_form;
        this.or_labor_regime_id = data[0].or_labor_regime_id;
        this.or_salary = data[0].or_salary;
        this.or_bonification = data[0].or_bonification;
        this.or_salary_per_day = data[0].or_salary_per_day;
        this.or_fortnight_amount = data[0].or_fortnight_amount;
        this.or_descuento_x_tardanza = parseFloat(
          data[0].or_descuento_x_tardanza
        );
        this.or_monthly_descuento_tardanza = parseFloat(
          data[0].or_monthly_descuento_tardanza
        );
        this.or_descuento_x_falta = parseFloat(data[0].or_descuento_x_falta);
        this.or_monthly_descuento_falta = parseFloat(
          data[0].or_monthly_descuento_falta
        );
        this.or_others_discount = parseFloat(data[0].or_others_discount);
        this.or_monthly_others_discount = parseFloat(
          data[0].or_monthly_others_discount
        );
        this.or_total_descuento = parseFloat(data[0].or_total_descuento);
        this.or_total_amount = parseFloat(data[0].or_total_amount);

        this.or_total_descuento_tardanzas =
          this.or_descuento_x_tardanza + this.or_monthly_descuento_tardanza;
        this.or_total_descuento_faltas =
          this.or_descuento_x_falta + this.or_monthly_descuento_falta;
        this.or_total_descuento_otros =
          this.or_others_discount + this.or_monthly_others_discount;



        const discounts = data[0].discounts;
        // data[0].discounts != null ? JSON.parse(data[0].discounts) : [];
        const attendances = data[0].attendances;
        // data[0].attendances != null ? JSON.parse(data[0].attendances) : [];

        this.discounts = discounts;
        this.attendances = attendances;
        this.data_salario_actual = data[0].data_salario_actual;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    async calculatePayrollById() {
      const confirm = await this.showConfirmSwal();
      if (!confirm.isConfirmed) return;

      try {
        this.addPreloader();
        const params = {
          end_date: this.cutOfDate,
          employee_id: this.employeeId,
          payroll_id: this.payrollId,
          user_id: this.currentUser.id,
        };

        if (this.isMonthly) {
          const data = await PayrollService.calculateMonthlyPayroll(params);
        } else {
          const data = await PayrollService.calculatePayroll(params);
        }

        this.showToastSuccess("Payroll calculated");
        await this.getDataOperationPayrollById();
      } catch (error) {
      } finally {
        this.removePreloader();
      }
    },

    async addDiscountToPayroll(discount) {
      if (this.isView) return;
      const check = discount.check;
      const confirm = await this.showConfirmSwal();
      if (confirm.isConfirmed) {
        try {
          this.addPreloader();
          const params = {
            payroll_id: this.payrollId,
            discount_fraction_id: discount.fraction_id,
            check,
          };
          const { data } = await PayrollService.addDiscountToOperationPayroll(
            params
          );
          if (data.type == "success") {
            this.showToastSuccess(data.msg);
          }
          this.isReadyApprove = 0;
        } catch (error) {
          console.log(error);
          this.showToastError(error.response?.data);
        } finally {
          this.removePreloader();
        }
      } else {
        if (check) {
          this.$set(discount, "check", 0);
          return;
        }
        this.$set(discount, "check", 1);
      }
    },

    async approvePayroll() {
      this.showConfirmacionPlanillaModal = true;
    },

    handleConfirmacionAprobacionPlanilla() {
      this.$emit("approvePayroll", {
        user_id: this.currentUser.id,
        payroll_id: this.payrollId,
      });
    },

    async refreshAttendance() {
      console.log("isview: ", this.isView);
      if (this.isView) return;
      try {
        this.addPreloader();
        const params = {
          attendance_id: this.attendanceId,
          payroll_id: this.payrollId,
          start_date: this.startDate,
          end_date: this.isMonthly ? this.cutOfDate : this.fortnightCutDay,
        };
        const { data } = await PayrollService.getAttendanceForPayroll(params);
        this.attendances = data;
        this.showToastSuccess("Refresh Attendance");
      } catch (error) {
        console.log(error);
        this.showToastError();
      } finally {
        this.removePreloader();
      }
    },

    async insertPersonalAttendance(item) {
      if (this.isView) return;
      if (this.isCeo || this.isChief) {
        try {
          this.addPreloader();
          const params = {
            date: item.date,
            attendance_id: this.attendanceId,
          };
          const { data } = await ViaticService.validateApprovedAttendance(
            params
          );
          this.attendanceData = {
            id: this.attendanceId,
            id_detail: item.id,
            code: this.attendanceCode,
            personal_name: this.employeeName,
            date: item.date,
            homework_status_id: item.hs_id,
            observation: item.observation,
            comment: item.comment,
            origin: "payroll",
            approved: data.isApproved,
            attendance_status_viatic_id: data.att?.attendance_status_viatic_id,
            payroll_id: this.payrollId,
          };
          this.personalAttendanceModal = true;
        } catch (error) {
          console.log(error);
        } finally {
          this.removePreloader();
        }
      } else {
        this.showToastWarning("Usuario no autorizado");
      }
    },

    resolvColor(hs_id) {
      if (hs_id == null) return "light-warning";
      switch (hs_id) {
        case 1:
          return "light-primary";
          break;
        case 2:
          return "light-success";
          break;
        case 3:
          return "light-danger";
          break;
        default:
          return "light-info";
          break;
      }
    },
  },
};
</script>

<style>
.scroll-kanban {
  height: 80vh;
  overflow-y: auto;
}

.py10 {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

/* Premium Styling Upgrades for Web Application Development Rule 2 & 3 */
::v-deep .card-app-design {
  border-radius: 12px;
  box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.05) !important;
  border: 1px solid rgba(115, 103, 240, 0.08) !important;
  transition: all 0.3s ease-in-out;
  margin-bottom: 1.5rem !important;
}

::v-deep .card-app-design:hover {
  box-shadow: 0 8px 25px 0 rgba(115, 103, 240, 0.1) !important;
  transform: translateY(-2px);
}

::v-deep .card-app-design .luxury-gradient-text {
  background: linear-gradient(90deg, #7367f0, #ce9ffc);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 800;
  letter-spacing: 0.5px;
  margin-bottom: 0.5rem !important;
  margin-top: 0.8rem !important;
  margin-left: 0.5rem !important;
  display: inline-block;
}

/* Improve tables */
::v-deep .card-app-design .b-table-simple {
  border-spacing: 0 6px !important;
  border-collapse: separate !important;
}

::v-deep .card-app-design .table-striped tbody tr:nth-of-type(odd),
::v-deep .card-app-design .table-striped tbody tr:nth-of-type(even) {
  background-color: rgba(115, 103, 240, 0.03) !important;
}

::v-deep .card-app-design tbody tr {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);
  border-radius: 6px;
  transition: all 0.2s ease;
}

::v-deep .card-app-design tbody tr:hover {
  transform: translateX(4px) scale(1.005);
  box-shadow: 0 4px 12px rgba(115, 103, 240, 0.06) !important;
  background-color: rgba(115, 103, 240, 0.06) !important;
}

::v-deep .card-app-design td {
  padding: 0.6rem 1rem !important;
  vertical-align: middle;
  border-top: none !important;
  border-bottom: none !important;
}

::v-deep .card-app-design td:first-child {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  font-weight: 600;
  color: #6e6b7b;
}

::v-deep .card-app-design td:last-child {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

::v-deep .card-app-design td.text-primary,
::v-deep .card-app-design td.text-danger {
  text-align: right;
  font-weight: 700;
}

::v-deep .card-app-design th {
  border: none !important;
  color: #b9b9c3;
  font-size: 0.75rem;
  letter-spacing: 1px;
  text-transform: uppercase;
}

/* Explicit Dark Mode Overrides for Vuexy */
.dark-layout ::v-deep .card-app-design .table-striped tbody tr:nth-of-type(odd),
.dark-layout ::v-deep .card-app-design .table-striped tbody tr:nth-of-type(even) {
  background-color: rgba(255, 255, 255, 0.02) !important;
}
.dark-layout ::v-deep .card-app-design tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.06) !important;
}
.dark-layout ::v-deep .my-badge {
  background: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
}
.dark-layout ::v-deep .card-app-design td:first-child {
  color: #b4b7bd;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  background: rgba(115,103,240,0.3);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: rgba(115,103,240,0.6);
}
</style>

<style lang="scss">
@import "@core/scss/vue/pages/page-profile.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>